import { render, staticRenderFns } from "./SpecificExhibitionPage.vue?vue&type=template&id=8e450e70&scoped=true&"
import script from "./SpecificExhibitionPage.vue?vue&type=script&lang=js&"
export * from "./SpecificExhibitionPage.vue?vue&type=script&lang=js&"
import style0 from "./SpecificExhibitionPage.vue?vue&type=style&index=0&id=8e450e70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e450e70",
  null
  
)

export default component.exports